import * as accessControlSchemas from "shadow-client/endpoints/accessControlApi/schemas";
import * as clubSchemas from "shadow-client/endpoints/clubApi/schemas";
import * as contactSchemas from "shadow-client/endpoints/contactApi/schemas";
import * as productSchemas from "shadow-client/endpoints/productApi/schemas";
import * as saleSchemas from "shadow-client/endpoints/saleApi/schemas";
import { denormalize } from "normalizr";
import Immutable from "immutable";

export const getEntities = state => state.entities || Immutable.Map();

/* Club API */
export const getClubs = (state, clubIds) =>
  denormalize(clubIds, [clubSchemas.club], getEntities(state)) || Immutable.List();
export const getClub = (state, clubId) => denormalize(clubId, clubSchemas.club, getEntities(state));

/* Product API */
export const getProducts = (state, productIds) =>
  denormalize(productIds, [productSchemas.product], getEntities(state)) || Immutable.List();
export const getProduct = (state, productId) => denormalize(productId, productSchemas.product, getEntities(state));

export const getProductBehaviors = (state, productBehaviorIds) =>
  denormalize(productBehaviorIds, [productSchemas.productBehavior], getEntities(state)) || Immutable.List();
export const getSpecificProductBehavior = (state, productBehaviorIds, behaviorType) => {
  const productBehaviors = getProductBehaviors(state, productBehaviorIds);
  return productBehaviors.find(productBehavior => productBehavior.get("behavior") === behaviorType);
};

export const getOffers = (state, offerIds) =>
  denormalize(offerIds, [productSchemas.offer], getEntities(state)) || Immutable.List();
export const getOffer = (state, offerId) => denormalize(offerId, productSchemas.offer, getEntities(state));

/* Sale API */
export const getSale = (state, saleId) => denormalize(saleId, saleSchemas.sale, getEntities(state));

export const getArticles = (state, articleIds) =>
  denormalize(articleIds, [saleSchemas.article], getEntities(state)) || Immutable.List();

/* Contact API */
export const getContacts = (state, contactIds) =>
  denormalize(contactIds, [contactSchemas.contact], getEntities(state)) || Immutable.List();
export const getContact = (state, contactId) =>
  denormalize(contactId, contactSchemas.contact, getEntities(state)) || Immutable.Map();

/* Access Control API */
export const getIdentificators = (state, identificatorIds) =>
  denormalize(identificatorIds, [accessControlSchemas.identificator], getEntities(state)) || Immutable.List();
export const getIdentificator = (state, identificatorId) =>
  denormalize(identificatorId, accessControlSchemas.identificator, getEntities(state)) || Immutable.Map();



// WEBPACK FOOTER //
// ./src/shadow-client/redux/selectors/index.js